// ======================================================================
// File Name       : ServiceConstant
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const ServiceType = [
  { name: '通常サービス', value: 0 },
  { name: 'コンテンツ配信サービス', value: 2 },
];

export const ServiceSortType = {
  serviceCd: 0,
  serviceName: 1,
  'enterpriseInfo.enterpriseName': 2,
  serviceType: 3,
};

export const PasswordStrength = [
  { name: '標準', value: 2 },
  { name: '中', value: 1 },
  { name: '強', value: 0 },
];

export const AvailableDisableUsage = [{ name: '利用なし', value: 0 }, { name: '利用あり', value: 1 }];

export const DormantState = [
    { name: '稼働中', value: 0 },
    { name: '休止中', value: 1 },
];

export const SERVICE_TYPE = {
  COURSE_NORMAL1: 0,
  COURSE_NORMAL2: 1,
  CONTENT_DISTRIBUTION: 2,
};

export const PUBLIC_STATUS = {
  ALL: null,
  PRIVATE: 0,
  PUBLIC: 1,
};

export const SERVICE_USER_TYPE = {
  USAGE_SCREEN: 0,
  HISTORY_BROWSING: 1,
  SERVICE: 2,
};

export const RELEASE_TARGET = {
  ALL: null,
  OVER_ALL: 0,
  INDIVIDUAL: 1,
};

export const AVAILABLE_DISABLE_USAGE = {
  AVAILABLE: 1,
  DISABLE: 0,
};

// Step SAML START
// Step 10.2.0 START
export const SAML_SERVICE_SETTING = {
  LOGIN_SUCCESS_REDIRECT_URL: 'https://ss-:domainName.l-cloud.jp/new/',
  LOGOUT_SUCCESS_REDIRECT_URL: 'https://ss-:domainName.l-cloud.jp/new/sso/logout/',
  ERROR_REDIRECT_URL: 'https://ss-:domainName.l-cloud.jp/new/sso/error/',
};
// Step 10.2.0 END
// Step SAML END
